<app-touareg-control-state-layout [locked]="true">
  <app-touareg-control-progress-button
    slot-middle
    [state]="state"
    [disabled]="okFetching || cancelFetching"
    (click)="onAccept()"
    (complete)="onComplete()"
    class="w-100 h-100"
  >
    <span *ngIf="okFetching" class="mr-1"
      ><mat-spinner diameter="15"></mat-spinner
    ></span>
    <span class="bb">Validate</span>
  </app-touareg-control-progress-button>

  <button
    slot-right
    [disabled]="okFetching || cancelFetching"
    (click)="onCancel()"
    class="w-100 h-100 btn-default btn-red"
  >
    <div class="d-flex flex-center">
      <span *ngIf="cancelFetching" class="mr-1"
        ><mat-spinner diameter="15"></mat-spinner
      ></span>
      <span class="bb">Correct</span>
    </div>
  </button>
</app-touareg-control-state-layout>
